import React from 'react';
import { css } from 'emotion';
import PropTypes from 'prop-types';
import { white, alloy, ocean, horizon } from '@cimpress/react-components/lib/colors';

const containerStyle = css({
  padding: '16px 16px 16px 25px',
  backgroundColor: `${white}`,
  border: `1px solid ${alloy}`,
  borderRadius: '4px',
  boxShadow: '0 1px 2px 0 rgba(0,0,0,0.1)',
  '&:active, &:hover': {
    border: `1px solid ${ocean.base}`,
    cursor: 'pointer'
  },
  '&:active': {
    background: `${horizon}`
  }
});

const titleStyle = css({
  margin: '0 0 16px 0'
});

const lineStyle = css({
  borderLeft: `2px solid ${alloy}`,
  paddingLeft: '10px'
});

function StatCard({ title, label, onClick, value, style }) {
  return (
    <div className={containerStyle} onClick={onClick} style={style}>
      <h2 className={titleStyle}>{title}</h2>
      <div className={lineStyle}>
        <h6>{label}</h6>
        <h1>{value}</h1>
      </div>
    </div>
  );
}

StatCard.propTypes = {
  title: PropTypes.string,
  label: PropTypes.string,
  onClick: PropTypes.func,
  value: PropTypes.number.isRequired
};

export default StatCard;
